/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'company-hub.links-menu-extension.alignment.title': 'Alineación',
  'company-hub.links-menu-extension.all.borders.label-text': 'Todos los lados',
  'company-hub.links-menu-extension.background.color': 'Color de fondo',
  'company-hub.links-menu-extension.background.title': 'Fondo',
  'company-hub.links-menu-extension.border.color': 'Color del borde',
  'company-hub.links-menu-extension.border.position': 'Posición del borde',
  'company-hub.links-menu-extension.bottom.border.label-text': 'Borde inferior',
  'company-hub.links-menu-extension.center.option': 'Centro',
  'company-hub.links-menu-extension.config-panel.add-link-button.description': 'Añadir enlaces importantes',
  'company-hub.links-menu-extension.config-panel.add-link-button.text': 'Enlace',
  'company-hub.links-menu-extension.config-panel.add-menu-button.description': 'Agrupar enlaces relacionados',
  'company-hub.links-menu-extension.config-panel.add-menu-button.disabled.tooltip-text':
    'Has alcanzado el número máximo de niveles anidados.',
  'company-hub.links-menu-extension.config-panel.add-menu-button.text': 'Menú',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.cancel-text': 'Cancelar',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.confirm-text': 'Eliminar',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.description-text':
    'Esta acción eliminará este elemento y todos los elementos anidados.',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.title-text': 'Eliminar elemento',
  'company-hub.links-menu-extension.config-panel.item-dropdown.add-sub-item-button.text': 'Añadir un subelemento',
  'company-hub.links-menu-extension.config-panel.item-dropdown.delete-item-button.text': 'Eliminar elemento',
  'company-hub.links-menu-extension.config-panel.item-dropdown.edit-properties-button.text': 'Editar propiedades',
  'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-down.text': 'Bajar',
  'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-up.text': 'Subir',
  'company-hub.links-menu-extension.config-panel.item-dropdown.open-link-button.text': 'Abrir el enlace',
  'company-hub.links-menu-extension.config-panel.items.label': 'Elementos',
  'company-hub.links-menu-extension.config-panel.new-item-button.disabled.tooltip-text':
    'Has alcanzado el número máximo de elementos que se pueden añadir a un menú de enlaces.',
  'company-hub.links-menu-extension.config-panel.new-item-button.text': 'Nuevo elemento',
  'company-hub.links-menu-extension.config-panel.preamble':
    'Añade enlaces y organízalos en submenús. {linksMenuSupportLink}',
  'company-hub.links-menu-extension.config-panel.preamble-link.label': 'Más información sobre el menú de enlaces',
  'company-hub.links-menu-extension.config-panel.preamble-without-support-link':
    'Añade enlaces y organízalos en submenús.',
  'company-hub.links-menu-extension.config-panel.property-config.cancel-button-label': 'Cancelar',
  'company-hub.links-menu-extension.config-panel.property-config.confirm-button-label': 'Confirmar',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-error': 'Rellena este campo.',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-label': 'Mostrar texto',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-placeholder': 'Nombre del elemento',
  'company-hub.links-menu-extension.config-panel.property-config.link.submit-button-label': 'Confirmar',
  'company-hub.links-menu-extension.config-panel.property-config.more-button-label': 'Más',
  'company-hub.links-menu-extension.config-panel.styles.label': 'Estilos',
  'company-hub.links-menu-extension.config-panel.sub-item-button.disabled.tooltip-text':
    'Has alcanzado el número máximo de elementos que se pueden añadir a un menú de enlaces.',
  'company-hub.links-menu-extension.config-panel.title': 'Menú Enlaces',
  'company-hub.links-menu-extension.fixed.option': 'Fijo en la parte superior',
  'company-hub.links-menu-extension.left.option': 'Izquierda',
  'company-hub.links-menu-extension.links-menu-content.links-menu-items.more.title': 'Más',
  'company-hub.links-menu-extension.manifest.extension-description':
    'Añade varios enlaces y submenús al centro empresarial',
  'company-hub.links-menu-extension.manifest.extension-lozenge-title': 'Menú Enlaces',
  'company-hub.links-menu-extension.manifest.extension-title': 'Menú Enlaces [Novedad]',
  'company-hub.links-menu-extension.manifest.first-default-item': 'Acerca de nosotros',
  'company-hub.links-menu-extension.manifest.nested-default-item': 'Equipo 1',
  'company-hub.links-menu-extension.manifest.second-default-item': 'Ventajas',
  'company-hub.links-menu-extension.manifest.third-default-item': 'Equipos',
  'company-hub.links-menu-extension.no.border.label-text': 'Ninguno',
  'company-hub.links-menu-extension.right.option': 'Derecha',
  'company-hub.links-menu-extension.section.collapse.label': 'Contraer sección',
  'company-hub.links-menu-extension.section.expand.label': 'Ampliar sección',
  'company-hub.links-menu-extension.selected.state.color': 'Color de estado seleccionado',
  'company-hub.links-menu-extension.text.color': 'Color del texto',
  'company-hub.links-menu-extension.text.title': 'Texto',
};
